const DefaultSiteFailedState = {
  payload: {
    initialLoading: true,
    flashMessage: null,
    error: "",
    success: "",
  },
  params: {
    limit: 25,
    page: 1,
    sort_order: "desc",
    sort_by: ``,
    q: ``,
  },
  modal: {
    mode: "",
  },
  status_modal: {
    mode: "",
  },
  organization_id: ``,
  fields: [
    { field: `job_id`, label: `Job Id`, sort: true },
    { field: `event`, label: `Event`, sort: true },
    { field: `created_at`, label: `Created At`, sort: true },
    { field: `updated_at`, label: `Updated At`, sort: true },
    { field: `status`, label: `Status`, sort: true },
  ],
};

export const SiteFailedState = { data: DefaultSiteFailedState };
